import { ApplicationModel, ApplicationResponse, GlobalResponseObject } from "@schemax-whatsapp/shared-models";
import { CommonAxiosServiceWp } from "./common-axios-service-wp";
import { AxiosRequestConfig } from "axios";
export class CompanyModuleService extends CommonAxiosServiceWp {
    private getURLwithMainEndPoint(childUrl: string) {
        return '/application/' + childUrl;
    }
    async addApplications(req: ApplicationModel, config?: AxiosRequestConfig):Promise<ApplicationResponse>{
        return await this.axiosPostCall(this.getURLwithMainEndPoint('addApplications'), req, config)
    }
    async getallApplications(config?: AxiosRequestConfig):Promise<ApplicationResponse>{
       const data = await this.axiosPostCall(this.getURLwithMainEndPoint('getallApplications'), config)
       return new ApplicationResponse (true, 201, 'Application created successfully', [data.data])
    }
}
